export function AdminEvent (pConfig)
{
  return (
  {
    name : 'EditorToolbarEventDescriptionLocalConfig',

    Groups :
    [
      {
        name : 'HistoryActionsPublic',
        visible : true
      },

      {
        name : 'BlockActionsPublic',
        visible : true
      },

      {
        name : 'TextAlignPublic',
        visible : true
      },

      {
        name : 'FontColorsPublic',
        visible : true
      },

      {
        name : 'InsertPublic',
        visible : true
      },

      {
        name : 'HTML',
        visible : true
      },

      {
        name : 'MoreEventDescriptionLocalActions',
        visible : true
      },

      {
        name : 'BlockStylesEventDescriptionPublic',
        visible : true,
        lineBreak : true
      },

      {
        name : 'TextDecorationPublic',
        visible : true
      },

      {
        name : 'TextDecorationDropdownPublic',
        visible : true,
        isDropdown: true
      }
    ]
  });
}